import { useEffect, useRef } from "react";

type Props = React.ComponentPropsWithoutRef<"div"> & {
  html?: string | null;
};

export const HtmlRenderer = ({ html, ...rest }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = html ?? "";
    }
  }, [html]);

  return <div ref={ref} {...rest} />;
};
